import { Text } from '@/components/shared/Text/Text';
import { TextField } from '@/components/shared/TextField/TextField';
import WithLoading from '@/lib/hoc/WithLoading/WithLoading';

import UsersTable from './components/ListUsersTable/UsersTable';
import { useListUsers } from './hooks/useListUsers';
import { useUserEmailSearch } from './hooks/useUserEmailSearch';

const REFRESH_INTERVAL = 15000;

const ListUsers = () => {
  const { activeEmail, searchEmail, setSearchEmail, handleClearField, handleKeyUp } =
    useUserEmailSearch();
  const { data: users = [], isLoading: isUsersLoading } = useListUsers(
    activeEmail,
    REFRESH_INTERVAL,
  );

  return (
    <div className="flex flex-col w-full">
      <Text.H4 weight="bold">Users</Text.H4>
      <div className="relative mt-4 w-[576px] mb-6">
        <TextField
          placeholder="Search User"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          onKeyUp={handleKeyUp}
          className="w-full"
          startIcon={<img src={'/icons/search.svg'} alt="search" width={24} height={24} />}
          endIcon={
            <button onClick={handleClearField}>
              <img src={'/icons/close.svg'} alt="search" width={24} height={24} />
            </button>
          }
        />
      </div>
      <WithLoading isLoading={isUsersLoading}>
        <UsersTable users={users} />
      </WithLoading>
    </div>
  );
};

export default ListUsers;
